import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { WaldLogo } from "../../components/site/WaldLogo";
import { useSeo } from "../../lib/seo";

export default function AdminLoginPage() {
  useSeo({ title: "Admin Login", description: "Wald admin panel.", path: "/admin/login" });
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Invalid credentials";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background wald-grid-bg">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md border border-border bg-card p-8">
        <div className="mb-8">
          <WaldLogo />
        </div>
        <div className="eyebrow mb-3">Admin Panel</div>
        <h1 className="font-display text-2xl tracking-tight mb-6">Sign in to continue</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <div className="eyebrow mb-2">Email</div>
            <input
              required
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-background border border-border px-3 py-2 rounded-sm text-sm focus:outline-none focus:border-[color:var(--wald-copper)]"
              placeholder="admin@wald.co.za"
            />
          </div>
          <div>
            <div className="eyebrow mb-2">Password</div>
            <input
              required
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-background border border-border px-3 py-2 rounded-sm text-sm focus:outline-none focus:border-[color:var(--wald-copper)]"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="btn-copper w-full justify-center disabled:opacity-70"
          >
            {busy ? <><Loader2 size={14} className="animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
